import React, { FC, useEffect, useState } from 'react'

import { DamageTypeSelectorProps, getDamageTypeHandler } from './damageTypes'

export const DamageTypeSelector: FC<DamageTypeSelectorProps> = ({
  editedAnnotation,
  setEditedAnnotation,
  inspectionType,
}) => {
  const [selectedTypes, setSelectedTypes] = useState<string[]>([])

  // Get handler - use a default if inspectionType is undefined (shouldn't happen due to conditional rendering)
  const handler = inspectionType ? getDamageTypeHandler(inspectionType) : null

  useEffect(() => {
    if (!handler) return
    const initialSelection = handler.getInitialSelection(editedAnnotation)
    setSelectedTypes(initialSelection)
  }, [editedAnnotation, handler])

  const handleSelectionChange = (newSelection: string[]) => {
    if (!handler) return
    setSelectedTypes(newSelection)
    handler.updateAnnotation(
      editedAnnotation,
      newSelection,
      setEditedAnnotation
    )
  }

  if (!handler) {
    return null
  }

  return (
    <>
      {handler.renderSelector(
        selectedTypes,
        handleSelectionChange,
        editedAnnotation,
        setEditedAnnotation
      )}
    </>
  )
}
